import { UserAvatar as UserAvatarBase, withSizeXL, withSizeL, withSizeS, } from '@yandex-int/hr-components/UserAvatar';
import { compose, composeU } from '@yandex-int/hr-components/lib/compose';

export const UserAvatar = compose(
    composeU(withSizeXL, withSizeL, withSizeS),
)(UserAvatarBase);
